import ICON__grid_2_2_check from '@/assets/icons/lucide/grid-2x2-check.svg?react';
import { buttonVariants, UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_6 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_6';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { FN_FIELD_IMAGE__edit } from '@/pages/page_generation/sidebar/image_asset/_methods/FN_FIELD_IMAGE__edit';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { VariantProps } from 'class-variance-authority';

interface PROPS {
  field: FIELD__image_asset;
  text?: string;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  size?: VariantProps<typeof buttonVariants>['size'];
}

export function G_GRAPH__BUTTON__image_asset_select_from_existing({ field, text = '', variant = 'no-border-on-bar', size = 'square-6' }: PROPS) {
  /*
   * STORE
   */
  const { g_image_edit__field, g_general__layout, g_image_edit__tab, g_general__ui_disabled } = use_slice_ui([
    'g_image_edit__field',
    'g_general__layout',
    'g_image_edit__tab',
    'g_general__ui_disabled',
  ]);

  /*
   * EVENTS
   */

  function onClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.stopPropagation();
    FN_FIELD_IMAGE__edit(field, ENUM__page_generation_layout.ASSETS, ENUM__page_generation_layout_images_edit_tab.SELECT);
  }

  function is_disabled() {
    if (g_general__ui_disabled) return true;

    return (
      g_general__layout == ENUM__page_generation_layout.ASSETS &&
      g_image_edit__tab == ENUM__page_generation_layout_images_edit_tab.SELECT &&
      g_image_edit__field.meta.field_id == field.meta.field_id
    );
  }

  /*
   * HTML
   */

  if (field.meta.kind__is_output) return <PLACEHOLDER_BUTTON__bar_6 />;
  if (field.meta.data__is_linked) return <PLACEHOLDER_BUTTON__bar_6 />;
  if (field.meta.ui__is_readonly) return <PLACEHOLDER_BUTTON__bar_6 />;

  return (
    <UI_PRIMITIVE__button disabled={is_disabled()} {...{ onClick, variant, size }} title="Select from existing">
      <ICON__grid_2_2_check className="!size-3" />
      {text}
    </UI_PRIMITIVE__button>
  );
}
